<template>
  <div>
    <md-table v-if="$store.state.pageLoaded" class="small-table">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button md-raised md-accent" v-on:click="editCreateDialogVisible = true; createDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(emptyCoupon))" title="Dodaj kupon" v-if="$store.state.schema.coupon.create">
            <md-icon>add</md-icon>
          </md-button>
          <h1 class="md-title">Kuponi</h1>
        </div>
      </md-table-toolbar>

      <md-table-row>
        <md-table-head>Naziv</md-table-head>
        <md-table-head>Cijena</md-table-head>
        <md-table-head>Organizacijska jedinica</md-table-head>
        <md-table-head>Mjesto troška</md-table-head>
        <md-table-head class="t-align-center">Akcije</md-table-head>
      </md-table-row>

      <md-table-row md-selectable="single" md-auto-select v-for="item in $store.state.receivedData.coupons.list" v-on:click="$store.state.selectedObject = JSON.parse(JSON.stringify(item))">
        <md-table-cell>{{ item.title }}</md-table-cell>
        <md-table-cell>{{ formatCurrency(item.price) }}</md-table-cell>
        <md-table-cell>{{ item.organization_unit }}</md-table-cell>
        <md-table-cell>{{ item.cost_center }}</md-table-cell>
        <md-table-cell class="actions-cell">
          <md-button class="md-icon-button md-accent" v-on:click="deleteDialog = true" title="Obriši" v-if="$store.state.schema.coupon.delete">
            <md-icon>delete</md-icon>
          </md-button>
          <md-button class="md-icon-button" v-on:click="editCreateDialogVisible = true; editDialog = true;" title="Uredi" v-if="$store.state.schema.coupon.update">
            <md-icon>edit</md-icon>
          </md-button>
          <md-button class="md-raised md-primary md-dense" v-on:click="sellCoupon = true" title="Prodaj">
            Prodaja
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm :md-active.sync="deleteDialog"
                md-title="Brisanje radnog mjesta"
                md-content="Jeste li sigurni?"
                md-confirm-text="Obriši"
                md-cancel-text="Zatvori"
                v-on:md-confirm="deleteSelected"
                >
    </md-dialog-confirm>

    <md-dialog :md-active.sync="editCreateDialogVisible" v-if="$store.state.selectedObject !== undefined" class="md-scrollbar">
      <md-dialog-title>{{ getDialogTitle }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <md-field :class="messageClass('title', $store.state.selectedObject)">
              <label>Naziv</label>
              <md-input v-model="$store.state.selectedObject.title"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('price', $store.state.selectedObject)">
              <label>Cijena</label>
              <md-input v-model="$store.state.selectedObject.price"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('organization_unit', $store.state.selectedObject)">
              <label>Organizacijska jedinica</label>
              <md-input v-model="$store.state.selectedObject.organization_unit"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('cost_center', $store.state.selectedObject)">
              <label>Mjesto troška</label>
              <md-input v-model="$store.state.selectedObject.cost_center"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="editCreateDialogVisible = false;">Zatvori</md-button>
            <md-button v-on:click="createOrUpdate" class="md-primary">Spremi</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>

    <md-dialog :md-active.sync="sellCoupon" class="md-scrollbar">
      <md-dialog-title>Prodaja kupona - {{ $store.state.selectedObject.title }}</md-dialog-title>
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <md-field :class="messageClass('count', sell)">
              <label>Količina</label>
              <md-input v-model="sell.count"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button v-on:click="sellCoupon = false;">Zatvori</md-button>
            <md-button v-on:click="sellPost()" class="md-primary">Prodaj</md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-card>
    </md-dialog>

    <md-dialog :md-active.sync="pay" :md-click-outside-to-close="false" :md-close-on-esc="false" class="dialog-container md-scrollbar">
      <md-dialog-title>Način plaćanja</md-dialog-title>
        <md-card-content>
          <div class="md-layout centered">
            <h4>Ukupna cijena: <strong>{{ amount }} kn</strong></h4>
            <md-radio v-model="paymentType" value="cash">Gotovina</md-radio>
            <md-radio v-model="paymentType" value="card">Kartica</md-radio>
            <md-radio v-model="paymentType" value="virman">Virman</md-radio>
            <md-radio v-model="paymentType" value="coupon">Darovni bon</md-radio>
            <md-checkbox v-model="r1">R1 račun</md-checkbox>
          </div>
          <div v-if="paymentType == 'card'" class="md-layout">
            <md-field>
              <label>Tip kartice</label>
              <md-select v-model="card_type">
                <md-option value="american">American</md-option>
                <md-option value="diners">Diners</md-option>
                <md-option value="maestro">Maestro</md-option>
                <md-option value="master">Master</md-option>
                <md-option value="visa">VISA</md-option>
                <md-option value="discovery">Discovery</md-option>
                <md-option value="v-pay">V Pay</md-option>
                <md-option value="union-pay">UnionPay</md-option>
              </md-select>
            </md-field>
            <md-field>
              <label>Broj rata</label>
              <md-select v-model="installments">/
              <md-option value="1">1</md-option>
              <md-option value="2">2</md-option>
              <md-option value="3">3</md-option>
              <md-option value="4">4</md-option>
              <md-option value="5">5</md-option>
              <md-option value="6">6</md-option>
              </md-select>
            </md-field>
          </div>
          <div v-show="r1" class="md-layout">
            <md-field :class="messageClass('name', r1Data)">
              <label>Naziv poduzeća</label>
              <md-input type="text" required v-model="r1Data.name"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('address', r1Data)">
              <label>Adresa</label>
              <md-input type="text" required v-model="r1Data.address"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('city', r1Data)">
              <label>Grad</label>
              <md-input type="text" required v-model="r1Data.city"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('postal_code', r1Data)">
              <label>Poštanski broj</label>
              <md-input type="text" required v-model="r1Data.postal_code"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('oib', r1Data)">
              <label>OIB</label>
              <md-input type="text" required v-model="r1Data.oib"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button class="md-accent md-dense md-raised" v-on:click="pay = false">
              Odustani
            </md-button>
            <md-button class="md-primary md-dense md-raised" v-on:click="setPayment()">
              Naplati
            </md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-dialog>
  </div>
</template>

<script>
import PaymentType from '../../mixins/payment-type.js'
import ListingMixin from '../../mixins/listing-mixin.js'
import FormatCurrency from "../../mixins/format-currency";


export default {
  name: 'coupons',
  data(){
    return {
      emptyCoupon: {
        title: '',
        price: '',
      },
      sell: {
        count: '',
        status: '',
      },
      pay: false,
      amount: 0,
      sellCoupon: false,
      requiredFields: ['title', 'price'],
    }
  },

  mixins: [ListingMixin('coupons', 'kupon'), PaymentType('fromBill'), FormatCurrency],

  methods:{
    sellPost(){
      this.passed = false;
      this.requiredFields = ['count']
      this.objectsToValidate = [this.sell];
      this.formSubmitted();
      if(this.passed){
        this.amount = this.sell.count * this.$store.state.selectedObject.price;
        this.pay = true;
        let context = {
          'kind': 'coupon',
          'count': this.sell.count,
          'status': 'offline_checkout',
          'coupon': this.$store.state.selectedObject.id,
        }
        this.$store.dispatch('createTransaction', {context});
      }
    },

    setPayment(){
      let context = {
        'payment_type': this.paymentType,
        'card_type': this.card_type,
        'installments': this.installments,
        'status': 'offline_sold',
        'coupon': this.$store.state.selectedObject.id,
        'kind': 'coupon'
      }
      if(this.r1){
        this.passed = false;
        this.requiredFields = ['oib', 'city', 'name', 'address', 'postal_code'];
        this.submited = true;
        this.objectToValidate = JSON.parse(JSON.stringify(this.r1Data));
        this.formSubmitted();
        if(this.passed) context['r1'] = this.r1Data;
      }
      else this.passed = true;

      if(this.passed){

        this.$store.dispatch('updateTransaction', {context});
        this.$store.dispatch('setActiveTab', 'transactionDetails');
      }
    },
  },

  watch:{
    editCreateDialogVisible(value){
      if(value){
        this.requiredFields = ['title', 'price'];
        this.objectsToValidate = [this.$store.state.selectedObject]
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .admin .md-table-content table .md-table-cell.actions-cell{
    width: 251px;
    max-width: 251px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Coupons.vue